import SelectBillCycle from '@app/views/Billing/update-bill-cycle-date/select-bill-cycle';
import UpdateBillCycle from '@app/views/Billing/update-bill-cycle-date/update-bill-cycle';
import InvoiceLoading from '@app/views/Invoice';
import PayBill from '@app/views/PayBill';

import { NestedRoutes, RouteRenderProps } from '../utils';
import { PayBillLink } from '../constants';

export const billingRoutes: RouteRenderProps[] = [
  {
    path: PayBillLink.PayBill,
    render: <PayBill />,
    exact: true,
    fromParent: 0,
  },
  {
    path: PayBillLink.UpdateBillCycle,
    render: <UpdateBillCycle />,
    exact: true,
    fromParent: 0,
  },
  {
    path: PayBillLink.Invoice,
    render: <InvoiceLoading />,
    exact: true,
    fromParent: 0,
    param: '/:invoice',
  },
  {
    path: PayBillLink.SelectBillCycle,
    render: <SelectBillCycle />,
    exact: true,
    fromParent: 1,
  },
];

export const BillingSwitch = (): JSX.Element => {
  return <NestedRoutes routes={billingRoutes} />;
};
